module.exports = __webpack_public_path__ + "media/licensing/page-background-18fa98cc.jpg";